import type { SkillKind } from '@lib/api-types/derived-contexts';
import { useState } from 'react';

/**
 * Per-view "Show Libraries" toggle. Libraries are noisy, so they're hidden by
 * default (matching {@link isDefaultVisibleSkill}); flip the toggle to include
 * them. Every other skill kind (frameworks, services, institutional) always
 * shows. This mirrors the Roadmap view's Show Libraries toggle so the control
 * reads the same across every matrix.
 */
export interface TechFilter {
  showLibraries: boolean;
  setShowLibraries: (value: boolean) => void;
  /** Whether a skill passes the filter — libraries only when the toggle is on. */
  visible: (skill: { kind: SkillKind }) => boolean;
}

/** Pure: is this kind visible given the Show Libraries toggle state? */
export function skillKindVisible(kind: SkillKind, showLibraries: boolean): boolean {
  return showLibraries || kind !== 'library';
}

export function useTechFilter(): TechFilter {
  const [showLibraries, setShowLibraries] = useState(false);
  return {
    showLibraries,
    setShowLibraries,
    visible: (skill) => skillKindVisible(skill.kind, showLibraries),
  };
}
